/** Decode lessontoc.openingNote / closingNote (JSON string or plain text). */
export function parseTocNoteFromApi(cell: unknown): string {
  if (cell == null || cell === '') return '';
  if (typeof cell === 'string') {
    const s = cell.trim();
    if (!s) return '';
    try {
      const parsed = JSON.parse(s);
      return String(parsed ?? '').trim();
    } catch {
      return s;
    }
  }
  return String(cell).trim();
}
